export const sanitizeOption = {
   allowedTags: ['h1', 'h2', 'b', 'i', 'u', 's', 'p', 'ul', 'ol', 'li', 'blockquote', 'a', 'img', 'span', 'strong', 'br', 'div', 'em'],
   allowedAttributes: {
      a: ['href', 'name', 'target'],
      img: ['src'],
      span: ['style'],
      strong: ['style'],
      div: ['style'],
      li: ['class'],
      p: ['style'],
   },
   //  이게 안되네 attributes는 체크하지 말아야 하나..
   // allowedStyles: {
   //     '*': {
   //       // Match HEX and RGB
   //       'color': [/^#(0x)?[0-9a-f]+$/i, /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/],
   //       'text-align': [/^left$/, /^right$/, /^center$/],
   //       // Match any number with px, em, or %
   //       'font-size': [/^\d+(?:px|em|%)$/]
   //     },
   //     'p': {
   //       'font-size': [/^\d+rem$/],
   //     }
   // },
   parseStyleAttributes: false,
};